import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';
import { AiChatBannerComponent } from '../ai-chat-banner/ai-chat-banner.component';
import { AiChatBarChartComponent } from '../ai-chat-bar-chart/ai-chat-bar-chart.component';
import { AiChatGenerativeButtonComponent } from '../ai-chat-button/ai-chat-button.component';
import { AiChatGaugeChartComponent } from '../ai-chat-gauge-chart/ai-chat-gauge-chart.component';
import { AiChatLineChartComponent } from '../ai-chat-line-chart/ai-chat-line-chart.component';
import { AiChatPieChartComponent } from '../ai-chat-pie-chart/ai-chat-pie-chart.component';
import { AiChatScoreComponent } from '../ai-chat-score/ai-chat-score.component';
import { AiChatSectionComponent } from '../ai-chat-section/ai-chat-section.component';
import { AiChatTableComponent } from '../ai-chat-table/ai-chat-table.component';

@Component({
  selector: 'app-ai-chat-generative-item',
  templateUrl: './ai-chat-generative-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AiChatSectionComponent,
    AiChatTableComponent,
    AiChatGenerativeButtonComponent,
    AiChatBarChartComponent,
    AiChatLineChartComponent,
    AiChatPieChartComponent,
    AiChatGaugeChartComponent,
    AiChatBannerComponent,
    AiChatScoreComponent,
  ],
  standalone: true,
})
export class AiChatGenerativeItemComponent {
  @Input() public chunk: IChatV2ComponentChunk;
}
